import Image from "next/image";
import React from "react";
import { ReadMoreLinkProps } from "@/types/ui-kit/ui";
import Link from "next/link";
import { useAppSelector } from "@/core/store/reduxHooks";
import { getCurrentTheme } from "@/core/store/app/AppSlice";
import { pushToDataLayer } from "@/utils/pushToDataLayer";

export const ReadMoreLink: React.FC<ReadMoreLinkProps> = ({ title, href, className }) => {
  const currentTheme = useAppSelector(getCurrentTheme);
  return (
    <Link
      href={href}
      className={`group flex items-center text-sm text-blue no-underline decoration-transparent transition-colors ease-in-out hover:decoration-current dark:text-middle-light-turquoise sm:text-md md:underline ${className}`}
      onClick={() =>
        pushToDataLayer({
          event: "article_interaction",
          interaction_type: "click_cta",
          interaction_option: title ?? "read more link",
        })
      }
    >
      {title}
      <Image
        src={`/assets/images/icons/${currentTheme === "" ? "arrow" : "arrow-dark"}.svg`}
        alt={title}
        className="ml-3 transition-transform ease-in-out group-hover:translate-x-1"
        width={30}
        height={30}
      />
    </Link>
  );
};
